(function () {
  // Target the inner WP block div, not the outer .container section wrapper.
  // The outer section may carry CSS transforms that shift the SVG filter
  // coordinate space away from the getBoundingClientRect() viewport coords.
  const section = document.querySelector('.wp-block-rinow-section.sc-hero')
               || document.querySelector('section.sc-hero');
  if (!section) return;

  section.classList.add('hero');

  // hero-inner non ajouté volontairement : le parallax scrubbed de scroll.js
  // réagit aux micro-scrolls du trackpad et fait bouger le titre sur mouse move

  // Eyebrow
  const eyebrow = section.querySelector('p.eyebrow');
  if (eyebrow) eyebrow.classList.add('hero-eyebrow');

  // Wrap each .line's children in a <span> for the GSAP yPercent clip reveal
  // Before: <span class="line">text</span>
  // After:  <span class="line"><span>text</span></span>
  section.querySelectorAll('h1 span.line').forEach(line => {
    const wrap = document.createElement('span');
    while (line.firstChild) wrap.appendChild(line.firstChild);
    line.appendChild(wrap);
  });

  // First paragraph after h1 (inside the nested columns) → hero-sub
  const subP = section.querySelector('h1 ~ .wp-block-columns .wp-block-column > p');
  if (subP) subP.classList.add('hero-sub');

  // Columns wrapper containing the CTA buttons → hero-actions (stagger entrance)
  const btnsCols = [...section.querySelectorAll('h1 ~ .wp-block-columns')]
    .find(col => col.querySelector('.wp-block-button'));
  if (btnsCols) btnsCols.classList.add('hero-actions');
})();
